var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import DeletionDialog from "../components/dialog/deletiondialog.vue";
import InlineEditLabel from "../components/inlineeditlabel.vue";
import PartCreationDialog from "../components/partcreation/partcreationdialog.vue";
import PartCreationSelectionDialog from "../components/partcreation/partcreationselectiondialog.vue";
import ProjectTableView from "../components/projecttableview.vue";
import QuickActionsDialog from "../components/quickactions/dialog.vue";
import ReadOnlyView from "../components/readonlymode/readonlyview.vue";
import RequestDialog from "../components/requestdialog.vue";
import Wizard from "../components/wizard/wizard.vue";
import { articleWithSheet, childArticles, emptyTableEntry, percentage, } from "./utilities/aux";
import { isDialogData, } from "./utilities/dialog";
import { articlePartState, createProject, isAssembly, isManufacturablePart, isPurchasedPart, isUserDefinedTube, PartState, } from "./utilities/documentdialog";
import { PartType, } from "./utilities/partcreation";
import { formatPrice, } from "./utilities/projecttable";
import { ProcessType, WorkStepType, Level, } from "./utilities/wsi4_interfaces";
import { computeResultingLevel, } from "./utilities/wsi4_typeguards";
const emptyDialogData = {
    selection: [],
};
function isManufacturable(article) {
    return articlePartState(article) !== PartState.notManufacturable;
}
let DocumentDialog = class DocumentDialog extends Vue {
    constructor() {
        super(...arguments);
        this.dialogData = emptyDialogData;
        this.partCreationType = PartType.rectangleCutout;
        this.requestData = [];
        this.showDeletionDialog = false;
        this.showPartCreationDialog = false;
        this.showPartCreationSelectionDialog = false;
        this.showReadOnlyView = false;
        this.articleDataChange = false;
    }
    closeWizard() { }
    clickRequest() {
        this.requestData = this.requestParts;
    }
    handleSaving() {
        this.networkBroker.save();
        this.dialogData = emptyDialogData;
        this.requestData = [];
    }
    handleRequest() {
        this.networkBroker.request();
        this.dialogData = emptyDialogData;
        this.requestData = [];
    }
    updateName(text) {
        if (!this.networkBroker.queueProjectNameRequest(text)) {
            return;
        }
        if (!this.networkBroker.queueGraphRequest()) {
            return;
        }
        this.networkBroker.process();
    }
    openDialog(data) {
        if (!isDialogData(data)) {
            throw Error("Wrong type");
        }
        this.dialogData = data;
    }
    openPartCreationSelectionDialog() {
        this.showPartCreationSelectionDialog = true;
    }
    openDeletionDialog(data) {
        this.showDeletionDialog = true;
        if (!isDialogData(data)) {
            throw Error("Wrong type.");
        }
        this.dialogData = data;
    }
    deleteSelection() {
        const vertexKeyArray = this.dialogData.selection.map(s => s.vertexKey);
        if (!this.networkBroker.queueDeleteRequest(vertexKeyArray)) {
            return;
        }
        if (!this.networkBroker.queueGraphRequest()) {
            return;
        }
        this.networkBroker.process();
        this.dialogData = emptyDialogData;
        this.showDeletionDialog = false;
    }
    openPartCreationDialog(p) {
        this.showPartCreationDialog = true;
        this.partCreationType = p;
    }
    closeDialog() {
        this.showDeletionDialog = false;
        this.dialogData = emptyDialogData;
        this.requestData = [];
    }
    setArticleDataChange(b) {
        this.articleDataChange = b;
    }
    get graphStructure() {
        const parentArticles = this.articles.filter((article) => article.nodes[article.nodes.length - 1].targets.length === 0);
        return parentArticles
            .map((article) => ({
            ...articleWithSheet(article, this.articles),
            subArticles: childArticles(article, this.articles),
        }))
            .sort((lhs, rhs) => lhs.nodes[0].rootIdKey.localeCompare(rhs.nodes[0].rootIdKey));
    }
    get openQuickActionsDialog() {
        return !this.showDeletionDialog && this.dialogData !== emptyDialogData;
    }
    get showRequestDialog() { return this.requestData.length !== 0; }
    get dialogOpen() {
        return this.openQuickActionsDialog || this.showRequestDialog || this.showDeletionDialog;
    }
    get saveButtonDisabled() { return this.articles.length === 0 || this.dialogOpen || this.requestParts.length !== 0 || this.articleDataChange; }
    get requestButtonDisabled() { return this.articles.length === 0 || this.dialogOpen || !this.saveButtonDisabled || this.articleDataChange; }
    get taxesInPercent() { return percentage(this.networkBroker.configuration.priceFactors.taxesFactor); }
    get discount() {
        return percentage(this.networkBroker.configuration.priceFactors.generalFactor);
    }
    get discountText() {
        return this.i18n.numberWithTwoDecimals(Math.abs(this.discount));
    }
    get showDiscount() {
        return this.networkBroker.configuration.priceFactors.transparent && this.discount < 0.;
    }
    get taxesPercentage() { return this.i18n.numberWithTwoDecimals(this.taxesInPercent); }
    get pricesWithTaxes() { return this.taxesInPercent > 0.; }
    get requestParts() {
        const filter = (p) => {
            if (isPurchasedPart(p)) {
                return true;
            }
            const level = computeResultingLevel(p.actualManufacturingState);
            if (level === Level.recoverableError || level === Level.fatalError) {
                return true;
            }
            if (isUserDefinedTube(p)) {
                return formatPrice(p.approxPrice, this.networkBroker.configuration.priceFactors, this.i18n) === emptyTableEntry;
            }
            if (p.processType === ProcessType.userDefinedTube) {
                return true;
            }
            if (isAssembly(p)) {
                return false;
            }
            if (!isManufacturablePart(p)) {
                return true;
            }
            return this.requestForcing ? p.forcedProcessType : false;
        };
        return [
            ...this.project.singleParts.filter(filter),
            ...this.project.assemblies.reduce((p, a) => {
                if (filter(a)) {
                    p.push(a);
                }
                return [
                    ...p,
                    ...a.parts.filter(filter),
                ];
            }, []),
        ];
    }
    get wizardVertexKeys() {
        const manufacturable = (article) => {
            if (!isManufacturable(article)) {
                return false;
            }
            return article.subArticles.every(s => isManufacturable(s));
        };
        return this.possibleWizardVertexKeys
            .filter(key => this.graphStructure.some(article => article.nodes.some(n => n.vertex === key && n.workStepType !== WorkStepType.userDefinedBase) && manufacturable(article)));
    }
    get showWizard() {
        return this.wizardVertexKeys.length !== 0;
    }
    get project() { return createProject(this.graphStructure, this.shopConfig, this.res); }
    get requestForcing() {
        return this.networkBroker.configuration.sheetMetalPartForcing.tag === "enabled" && this.networkBroker.configuration.sheetMetalPartForcing.type === "request";
    }
    get requestButtonToolTip() {
        if (this.requestButtonDisabled) {
            if (this.articleDataChange) {
                return this.i18n.t("uncommittedChangesWarning");
            }
            else {
                return this.i18n.t("requestToolTipDisabled");
            }
        }
        return this.i18n.t("requestToolTip");
    }
    get saveButtonToolTip() {
        if (this.saveButtonDisabled) {
            if (this.articleDataChange) {
                return this.i18n.t("uncommittedChangesWarning");
            }
            else {
                return this.i18n.t("requestWarning");
            }
        }
        else {
            return this.i18n.t("save");
        }
    }
    created() {
        this.showReadOnlyView = this.readOnlyModeEnabled;
    }
    onReadOnlyModeEnabledChanged() {
        this.showReadOnlyView = this.readOnlyModeEnabled;
    }
    onShopConfigChanged() {
        this.showPartCreationSelectionDialog = this.showPartCreationButton && this.networkBroker.configuration.partCreationConfig.showOnStartUp;
    }
};
__decorate([
    Prop({ required: true })
], DocumentDialog.prototype, "articles", void 0);
__decorate([
    Prop({ required: true })
], DocumentDialog.prototype, "name", void 0);
__decorate([
    Prop({ required: true })
], DocumentDialog.prototype, "possibleWizardVertexKeys", void 0);
__decorate([
    Prop({ required: true })
], DocumentDialog.prototype, "price", void 0);
__decorate([
    Prop({ required: true })
], DocumentDialog.prototype, "readOnlyModeEnabled", void 0);
__decorate([
    Prop({ required: true })
], DocumentDialog.prototype, "Renderer3d", void 0);
__decorate([
    Prop({ required: true })
], DocumentDialog.prototype, "res", void 0);
__decorate([
    Prop({ required: true })
], DocumentDialog.prototype, "shopConfig", void 0);
__decorate([
    Prop({ required: true })
], DocumentDialog.prototype, "showPartCreationButton", void 0);
__decorate([
    Inject()
], DocumentDialog.prototype, "networkBroker", void 0);
__decorate([
    Inject()
], DocumentDialog.prototype, "i18n", void 0);
__decorate([
    Emit()
], DocumentDialog.prototype, "closeWizard", null);
__decorate([
    Watch("readOnlyModeEnabled")
], DocumentDialog.prototype, "onReadOnlyModeEnabledChanged", null);
__decorate([
    Watch("shopConfig")
], DocumentDialog.prototype, "onShopConfigChanged", null);
DocumentDialog = __decorate([
    Component({
        components: {
            DeletionDialog,
            InlineEditLabel,
            PartCreationDialog,
            PartCreationSelectionDialog,
            ProjectTableView,
            QuickActionsDialog,
            ReadOnlyView,
            RequestDialog,
            Wizard,
        },
        name: "DocumentDialog",
    })
], DocumentDialog);
export default DocumentDialog;
